import { App as Table } from 'map-table'
import { memo } from 'react'
import { useFilterResults } from '~map-filter-view/states/filter'
import { useJsonFeatures, useProperties } from '~map-preview/states/map'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { useCategories } from '~map-preview/states/map'
import { useGeojsonData } from '~map-preview/hooks/useGeojsonData'
import { MS_UUID, getCategoryMarkerStyle } from 'map-style-utils'

const Component = (props) => {
  const filterResults = useFilterResults()
  const properties = useProperties()
  const jsonFeatures = useJsonFeatures()
  const geojson = useGeojsonData()
  const categories = useCategories()
  const updatedProperties = properties.map((prop) => {
    const isCategory = Object.keys(categories).includes(prop.name)
    return {
      ...prop,
      isCategory,
      categoryStyle:
        geojson &&
        isCategory &&
        getCategoryMarkerStyle(geojson, {
          aggregateBoundary: MS_UUID,
          aggregateProperty: prop.name,
          selected: ''
        })?.legend?.classes
    }
  })

  return (
    <Table
      {...props}
      shouldUseCollapse={false}
      filters={[]}
      filterResults={filterResults}
      properties={updatedProperties}
      jsonFeatures={jsonFeatures}
    />
  )
}

const MapTable = memo(function MapTable(props) {
  const { openTable, setOpenTable } = useMapNavStore()

  const handleClose = () => {
    setOpenTable(false)
  }

  if (!openTable) return null

  return (
    <Component
      {...props}
      onClose={handleClose}
    />
  )
})

export { MapTable }
